import {
  Control,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  Merge,
  Path,
  useController,
} from "react-hook-form";
import { useState, useEffect, useRef } from "react";
import { axiosPrivate } from "../../api/axios";
import { ReactComponent as Close } from "../../iconColor/x.svg";

export interface IdTitleOwnershipModel {
  id: string;
  name: string;
}

type Props<Model, FieldModel extends FieldValues> = {
  withAPI?: boolean;
  APIPath?: string;
  APIgetValue?: any;
  mode?: "default" | "withRadio" | "multiSelect";
  size?: "small" | "regular" | "large" | undefined;
  label: string;
  uidName?: any;
  options?: Model[];
  control: Control<FieldModel, any>;
  name: Path<FieldModel> | any;
  errors?: FieldError | Merge<FieldError, FieldErrorsImpl<FieldModel>>;
  disabled?: boolean;
  success?: boolean;
  isRequired?: boolean;
  MarginTop?: boolean;
  showNonOption?: boolean;
  defaultSelectValue?: any;
  flex?: string | number;
  secondaryBackground?: boolean;
  customOptionGenerator?: (option: Model) => JSX.Element;
  onChange?(value: Model | null): string | string[] | void;
  setValue?(name: any, id: any): any;
};

function MultiSellectCheckboxCom<Model, FieldModel extends FieldValues>(
  props: Props<Model, FieldModel>
) {
  const {
    field: { onChange, value },
  } = useController({
    name: props.name,
    control: props.control,
  });

  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  const selectRef2 = useRef<HTMLDivElement>(null);
  const [productGroup, setProductGroup] = useState([
    // {
    //   product_group_uid: "9f073ec2-2b50-4a03-a9a1-351c84982067",
    //   name: "لوازم خانگی",
    //   is_active: true,
    //   state: false,
    // },
  ]);

  const fetchProductGroup = async () => {
    if (props.withAPI) {
      try {
        const response = await axiosPrivate.get(`${props.APIPath}`, {
          headers: {
            accept: "application/json",
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        });

        var res = response.data.data.result;

        for (let i = 0; i < res.length; i++) {
          res[i]["state"] = false;
        }

        if (!(isChecked.length > 2)) {
          setisChecked(res);
          setSelectData(res);
        }
      } catch (error) {
        console.error("Error fetching job category:", error);
      }
    }
  };

  const handleToggleOptionsCheckBox = () => {
    checkboxes = document.getElementById("checkBoxes");

    if (!show) {
      setSelectIconStyle("rotate(180deg)");
      if (checkboxes !== null) {
        checkboxes.style.display = "flex";
      }
    } else {
      setSelectIconStyle("rotate(0deg)");
      if (checkboxes !== null) {
        checkboxes.style.display = "none";
      }
    }
    setShow(!show);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        mouseDownCH();
        setSelectIconStyle("rotate(0deg)");
      }

      if (
        selectRef2.current &&
        !selectRef2.current.contains(event.target as Node)
      ) {
        if (!isOpen) {
          setSelectIconStyle("rotate(0deg)");
        } else {
          setSelectIconStyle("rotate(180deg)");
        }

        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchProductGroup();
    checkboxes = document.getElementById("checkBoxes");
    if (checkboxes !== null) {
      checkboxes.style.display = "none";
    }

    if (props.mode === "withRadio") {
      onChange([] ?? null);
    }
  }, []);

  const [selectIconStyle, setSelectIconStyle] = useState("rotate(0deg)");

  const ref = useRef<any>(null);
  const [Checked, setChecked] = useState([]);
  const [itemsIsChoosed, setItemsIsChoosed] = useState(false);
  const [isChecked, setisChecked] = useState(
    JSON.parse(JSON.stringify(props.withAPI ? productGroup : props.options))
  );
  const [selectData, setSelectData] = useState(
    JSON.parse(JSON.stringify(props.withAPI ? productGroup : props.options))
  );

  var checkboxes: HTMLElement | null = null;

  const Dellhandeler = (uid: string) => {
    var Idx = isChecked;
    var id = Idx.findIndex((obj: any) => obj[props.uidName] == uid);
    Idx[id]["state"] = false;

    for (var i = 0; i < Idx.length; i++) {
      if (Idx[i]["state"] === true) {
        setItemsIsChoosed(true);
        setChecked(Idx?.filter((el: any) => el.state === true));
        break;
      } else {
        setItemsIsChoosed(false);
        setChecked([]);
      }
    }

    const checkboxOutput = [];
    for (var i = 0; i < Idx.length; i++) {
      if (Idx[i]["state"] === true) {
        checkboxOutput.push(String(Idx[i][props.uidName]));
      }
    }
    onChange(checkboxOutput ?? null);
    if (props.setValue) {
      props.setValue(props.name, JSON.stringify(checkboxOutput));
    }
    setisChecked(Idx);
  };

  const HanddelCheckboxs = (id: number, event: boolean) => {
    var Idx = isChecked;

    Idx[id]["state"] = event;

    for (var i = 0; i < Idx.length; i++) {
      if (Idx[i]["state"] === true) {
        setItemsIsChoosed(true);
        setChecked(Idx?.filter((el: any) => el.state === true));
        break;
      } else {
        setItemsIsChoosed(false);
        setChecked([]);
      }
    }
    const checkboxOutput = [];
    for (var i = 0; i < Idx.length; i++) {
      if (Idx[i]["state"] === true) {
        checkboxOutput.push(String(Idx[i][props.uidName]));
      }
    }
    onChange(checkboxOutput ?? null);
    if (props.setValue) {
      props.setValue(props.name, JSON.stringify(checkboxOutput));
    }

    setisChecked(Idx);
  };

  const HanddelCheckboxsOnText = (uid: string) => {
    var Idx = isChecked;
    var id = Idx.findIndex((obj: any) => obj[props.uidName] == uid);
    var value = Idx[id]["state"];
    Idx[id]["state"] = !value;

    for (var i = 0; i < Idx.length; i++) {
      if (Idx[i]["state"] === true) {
        setItemsIsChoosed(true);
        setChecked(Idx?.filter((el: any) => el.state === true));
        break;
      } else {
        setItemsIsChoosed(false);
        setChecked([]);
      }
    }
    const checkboxOutput = [];
    for (var i = 0; i < Idx.length; i++) {
      if (Idx[i]["state"] === true) {
        checkboxOutput.push(String(Idx[i][props.uidName]));
      }
    }

    onChange(checkboxOutput ?? null);
    if (props.setValue) {
      props.setValue(props.name, JSON.stringify(checkboxOutput));
    }
    setisChecked(Idx);
  };

  function mouseDownCH() {
    checkboxes = document.getElementById("checkBoxes");
    if (checkboxes !== null) {
      checkboxes.style.display = "none";
    }
  }

  const getHeight = {
    small: "h-[92px]",
    regular: "h-[100px]",
    large: "h-[116px]",
  }[props?.size || "small"];

  useEffect(() => {
    if (props.APIgetValue !== undefined && isChecked !== undefined) {
      var sample = isChecked;

      for (let i = 0; i < sample.length; i++) {
        for (let j = 0; j < props.APIgetValue.length; j++) {
          if (
            props.APIgetValue[j]["product_group_uid"] ===
            sample[i]["product_group_uid"]
          ) {
            sample[i]["state"] = true;
          }
        }
      }

      const checkboxOutput = [];
      for (var i = 0; i < sample.length; i++) {
        if (sample[i]["state"] === true) {
          checkboxOutput.push(String(sample[i][props.uidName]));
        }
      }
      onChange(checkboxOutput ?? null);
      if (props.setValue) {
        props.setValue(props.name, JSON.stringify(checkboxOutput));
      }
      setChecked(sample?.filter((el: any) => el.state === true));

      setisChecked([...sample]);
      setSelectData([...sample]);
    }
  }, [props.APIgetValue, isChecked]);
  return (
    <>
      <div
        ref={selectRef}
        className="flex w-full p-0 flex-col items-start gap-2 shrink-0 mt-6"
      >
        <label className=" self-stretch text-right text-gray-900 text-Body-OneLine/14/Regular">
          {props.label}
          {props.isRequired && (
            <>
              <span className="text-red-500">*</span>
            </>
          )}
        </label>
        <div className=" w-full relative">
          <div
            onClick={handleToggleOptionsCheckBox}
            className={`flex ${
              props.errors?.message !== undefined
                ? `text-red-600 border-red-500 bg-red-100 focus:text-red-700`
                : ``
            } flex-wrap justify-between pt-3 pb-3 pr-4 pl-4 content-end items-center gap-2.5 self-stretch rounded-lg border border-solid border-gray-300 bg-gray-50`}
          >
            {isChecked?.filter((el: any) => el.state === true).length !== 0 ? (
              <>
                <div className="flex content-center flex-wrap p-0 items-center gap-2.5">
                  {Checked?.map((data: any) => (
                    <div
                      key={data[props.uidName]}
                      className="flex overflow-clip  items-center gap-1 rounded-md bg-gray-100 flex-shrink-0"
                    >
                      <div
                        className="p-1.5 hover:bg-red-200"
                        onClick={() => Dellhandeler(data[props.uidName])}
                      >
                        {/* <img
                          className="hover:bg-red-200 h-3 w-3"
                          src="/icons/x.svg"
                          alt="x icon not found"
                        /> */}
                        <Close />
                      </div>
                      <div className="p-0.5">
                        <p className=" text-gray-900 text-center Body-OneLine/12/Regular break-normal overflow-clip flex-shrink-0">
                          {data.name}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="h-4 flex items-center">
                  {props.defaultSelectValue}
                </div>
                <div
                  className={`w-4 h-4 bg-no-repeat bg-center dropdown-arrow`}
                  style={{
                    transform: selectIconStyle,
                    backgroundImage: "url(/icons/chevron-down-outline.svg)",
                  }}
                ></div>
              </>
            )}
          </div>
          <div
            id="checkBoxes"
            className="flex flex-col w-full z-30 absolute items-start gap-0 bg-white self-stretch border-gray-700 border rounded-lg"
          >
            {isChecked?.map((data: any, index: number) => (
              <div
                key={data[props.uidName]}
                className="flex pt-2 pb-2 pr-4 pl-4 justify-right items-center gap-2 self-stretch"
              >
                <input
                  className=" flex w-4 h-4 p-3 flex-col justify-center items-center gap-3 rounded "
                  checked={isChecked[index]["state"]}
                  onChange={(e) => HanddelCheckboxs(index, e.target.checked)}
                  type="checkbox"
                  id={`${data[props.uidName]}`}
                />
                <div
                  onClick={() => HanddelCheckboxsOnText(data[props.uidName])}
                  className={` text-gray-700 BodyText/14/Regular`}
                >
                  {data.name}
                </div>
              </div>
            ))}
          </div>
        </div>
        {props.errors && (
          <p className="text-red-500 text-sm ">
            {props.errors.message?.toString()}
          </p>
        )}
      </div>
    </>
  );
}

export default MultiSellectCheckboxCom;
